export default __webpack_public_path__ + "assets/images/3055c2d6cfee8585ba8839dac40c0022.jpg";